<template>
    <sequential-entrance fromBottom>
  <v-card class="video-card" style="padding: 20px; width: 100%">
  <youtube :video-id="videoId" :player-vars="playerVars" @playing="playing"></youtube>
	</v-card>
  </sequential-entrance>
</template>

<script>
export default {
  data() {
    return {
      videoId: '1LH5JcJtV94',
      playerVars: {
        autoplay: 1
      }
    }
  },
  methods: {
    playing() {
      console.log('We are watching!!!')
    }
  }
}
</script>



<style scoped>

.video-card {
 background: rgba(48, 64, 87, 0.1);
 outline-color: rgba(90, 128, 191, 0.3);
 outline-style: solid;
 border-color: #5a80bf;
 box-shadow: 0 0 5px rgba(90,128,191,.4), inset 0 0 0px rgba(90,128,191,.2), 0 0px 0 #000;
 color: #efe;
 outline-width: 2px;
 margin: 0 auto;
 bottom-padding: 50px;
}

.video-card:hover {
  background: rgba(48, 64, 87, 0.3);
  outline-color: rgba(90, 128, 191, 0.45);
  outline-style: solid;
	border-color: #5a80bf;
	box-shadow: 0 0 10px rgba(90,128,191,.6), inset 0 0 7px rgba(90,128,191,.4), 0 2px 0 #000;
	color: #efe;
  outline-width: 3px;
	margin: 0 auto;
  bottom-padding: 50px;
}

</style>
